import { useState } from 'react';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import Iconify from '../../../../reusable-components/iconify';
import { useDeleteAndNavigate } from './reusable/hooks/useDeleteAndNavigate';
import { useIsInvoiceEditable } from './reusable/hooks/useInvoiceLocks';
import DropdownAction from '../../../../reusable-components/dropdown-action/DropdownAction';
import { ConfirmDialog } from '../../../../reusable-components/confirm-dialog';

const InvoiceMenuActions = () => {
  const { isEditable: hasEditAccess, message } = useIsInvoiceEditable(true);

  const deleteAndNavigate = useDeleteAndNavigate();
  const [isInvoiceDeleteInProgress, setIsInvoiceDeleteInProgress] = useState(false);

  const [deleteMenuAnchorEl, setDeleteMenuAnchorEl] = useState(null);
  const handleInvoiceDelete = async () => {
    try {
      setIsInvoiceDeleteInProgress(true);
      await deleteAndNavigate();
    } finally {
      setIsInvoiceDeleteInProgress(false);
      setDeleteMenuAnchorEl(null);
    }
  };
  return (
    <>
      <Tooltip title={!hasEditAccess ? message : ''}>
        <IconButton onClick={(event) => setDeleteMenuAnchorEl(event.currentTarget)}>
          <Iconify icon="mdi:dots-horizontal" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={deleteMenuAnchorEl}
        open={Boolean(deleteMenuAnchorEl)}
        onClose={() => setDeleteMenuAnchorEl(null)}
        slotProps={{
          paper: {
            sx: {
              width: 220,
              p: 1,
              borderRadius: '5px',
              boxShadow: '0px 2px 6px rgba(0,0,0,.06), 0px 8px 24px rgba(0,0,0,.12)',
            },
          },
          list: {
            sx: {
              display: 'flex',
              flexDirection: 'column',
              p: 0,
            },
          },
        }}
      >
        <MenuItem disableRipple disableGutters sx={{ p: 0, minHeight: 'unset' }}>
          <DropdownAction
            buttonComponent={ConfirmDialog}
            badgeIcon="ic:outline-delete"
            iconColor="error.main"
            iconBgColor="#FDEDED"
            textColor="error.main"
            button="text"
            title="Delete Invoice"
            color="error"
            disabled={!hasEditAccess}
            content="Are you sure you want to delete this invoice?"
            actionButton="Delete"
            action={handleInvoiceDelete}
            icon="delete-outline"
            tooltip="Delete"
            manualLoading={isInvoiceDeleteInProgress}
          >
            Delete Invoice
          </DropdownAction>
        </MenuItem>
      </Menu>
    </>
  );
};
export default InvoiceMenuActions;
